/* R36S landing — interactividad + carrito real sobre el diseño exportado (Higgsfield) dentro de Shopify. */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var APP = document.getElementById('r36sApp');
    if (!APP) return;
    var DATA = (window.__R36 && window.__R36.variants) || [];

    // ---- 0) Reveal (el observer era React; sin él todo .reveal queda invisible) ----
    var reveals = Array.prototype.slice.call(APP.querySelectorAll('.reveal'));
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -10% 0px' });
      reveals.forEach(function (n) { io.observe(n); });
    } else {
      reveals.forEach(function (n) { n.classList.add('visible'); });
    }

    // ---- variantes normalizadas ----
    function colorOf(t) {
      t = (t || '').toLowerCase();
      if (t.indexOf('ruby') >= 0) return 'ruby';
      if (t.indexOf('black') >= 0) return 'black';
      if (t.indexOf('white') >= 0) return 'white';
      if (t.indexOf('yellow') >= 0) return 'yellow';
      if (t.indexOf('purple') >= 0) return 'purple';
      if (t.indexOf('orange') >= 0) return 'orange';
      if (t.indexOf('blue') >= 0) return 'blue';
      if (t.indexOf('red') >= 0) return 'red';
      return 'black';
    }
    var V = DATA.map(function (v) { return { id: v.id, s: /128/.test(v.t) ? '128gb' : '64gb', c: colorOf(v.t), avail: v.avail !== false }; });
    function findVar(s, c) {
      return V.filter(function (v) { return v.s === s && v.c === c; })[0]
        || V.filter(function (v) { return v.s === s; })[0]
        || V[0];
    }

    var PRICE = { '64gb': { p: '59,99 €', o: '64,99 €', sv: '5,00 €' }, '128gb': { p: '64,99 €', o: '69,99 €', sv: '5,00 €' } };
    var state = { s: '64gb', c: 'black' };
    var $ = function (sel, el) { return (el || APP).querySelector(sel); };
    var $$ = function (sel, el) { return Array.prototype.slice.call((el || APP).querySelectorAll(sel)); };
    function byText(sel, txt, el) { return $$(sel, el).filter(function (n) { return (n.textContent || '').trim().indexOf(txt) >= 0; }); }

    // ---- 1) Stats (CountUp se quedó en 0 sin React) ----
    var stats = $$('.gradient-neon');
    var statVals = ['21', '15.000+', '6h', '2'];
    stats.forEach(function (n, i) { if (statVals[i]) n.textContent = statVals[i]; });
    // relabel 4ª stat (venta inventada) -> honesto
    if (stats[3]) {
      var box = stats[3].parentElement;
      if (box) {
        var lab = box.querySelector('.text-sm'); var sub = box.querySelector('.text-xs');
        if (lab) lab.textContent = 'MicroSD';
        if (sub) sub.textContent = 'Sistema + juegos';
      }
    }

    // ---- 2) Precios dinámicos (hero) ----
    function updatePrice() {
      var pc = PRICE[state.s];
      var hero = $('#inicio');
      if (hero) {
        var big = hero.querySelector('.font-display.text-5xl.tnum'); if (big) big.textContent = pc.p;
        var old = hero.querySelector('.line-through.tnum'); if (old) old.textContent = pc.o;
        byText('span', 'Ahorra', hero).forEach(function (n) { n.textContent = 'Ahorra ' + pc.sv; });
        byText('p', 'El precio sube', hero).forEach(function (n) { n.textContent = 'El precio sube a ' + pc.o + ' al acabar'; });
      }
    }

    // ---- 3) Selector de almacenamiento ----
    function styleStorage() {
      $$('button').forEach(function (b) {
        var h = b.querySelector('.font-display.text-2xl');
        if (!h) return;
        var t = h.textContent.trim();
        if (t !== '64GB' && t !== '128GB') return;
        var sel = (t === '64GB' && state.s === '64gb') || (t === '128GB' && state.s === '128gb');
        // limpiar clases de estado
        ['border-[#22D3EE]', 'bg-[#22D3EE]/5', 'glow-border-cyan', 'border-[#7C3AED]', 'bg-[#7C3AED]/5', 'glow-border-purple', 'glow-pulse', 'border-white/10'].forEach(function (cl) { b.classList.remove(cl); });
        if (sel) {
          if (t === '64GB') { b.classList.add('border-[#22D3EE]', 'bg-[#22D3EE]/5', 'glow-border-cyan'); }
          else { b.classList.add('border-[#7C3AED]', 'bg-[#7C3AED]/5', 'glow-border-purple'); }
        } else { b.classList.add('border-white/10'); }
      });
    }
    $$('button').forEach(function (b) {
      var h = b.querySelector('.font-display.text-2xl'); if (!h) return;
      var t = h.textContent.trim();
      if (t === '64GB' || t === '128GB') {
        b.addEventListener('click', function (e) { e.preventDefault(); state.s = (t === '64GB') ? '64gb' : '128gb'; updatePrice(); styleStorage(); });
      }
    });

    // ---- 3b) Miniaturas seleccionables -> cambian la imagen grande ----
    var heroSec = document.getElementById('inicio');
    if (heroSec) {
      var mainImg = heroSec.querySelector('img');
      $$('#inicio button img').forEach(function (t) {
        var btn = t.parentElement; btn.style.cursor = 'pointer';
        btn.addEventListener('click', function (e) { e.preventDefault(); if (mainImg) mainImg.src = t.src; });
      });
    }

    // ---- 4) Selector de color ----
    var swatches = $$('button[aria-label]').filter(function (b) { return b.style && b.style.backgroundColor; });
    var nameMap = { 'Negro': 'black', 'Blanco': 'white', 'Amarillo': 'yellow', 'Purpura': 'purple', 'Púrpura': 'purple', 'Transparente': 'transparent' };
    swatches.forEach(function (b) {
      b.addEventListener('click', function () {
        var key = nameMap[(b.getAttribute('aria-label') || '').trim()] || 'black';
        state.c = key;
        swatches.forEach(function (x) { x.classList.remove('border-white', 'scale-110'); x.classList.add('border-white/20'); });
        b.classList.remove('border-white/20'); b.classList.add('border-white', 'scale-110');
        byText('p', 'Color:', APP).forEach(function (n) {
          var span = n.querySelector('span'); if (span) span.textContent = (b.getAttribute('aria-label') || '');
        });
        // mostrar la consola en ese color real (foto Ali) en la imagen grande
        if (window.__R36IMG && window.__R36IMG[key] && mainImg) mainImg.src = window.__R36IMG[key];
      });
    });

    // ---- 5) Contador real hasta 6 jul 2026 23:59 (+02:00) ----
    var END = new Date('2026-07-06T23:59:59+02:00').getTime();
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var d = END - Date.now(); if (d < 0) d = 0;
      var h = Math.floor(d / 3.6e6), m = Math.floor(d % 3.6e6 / 6e4), s = Math.floor(d % 6e4 / 1e3);
      var nums = $$('.font-display.text-xl.tnum');
      for (var i = 0; i + 2 < nums.length + 1; i += 3) {
        if (nums[i]) nums[i].textContent = pad(h);
        if (nums[i + 1]) nums[i + 1].textContent = pad(m);
        if (nums[i + 2]) nums[i + 2].textContent = pad(s);
      }
    }
    tick(); setInterval(tick, 1000);

    // ---- 6) FAQ (SSR solo trae la 1ª respuesta) ----
    var FAQ = {
      'Que sistemas soporta?': 'Soporta 21 emuladores. Destacados: PS1, SNES, GBA, NES, N64, PSP y Dreamcast. El rendimiento puede variar por juego y configuración.',
      'Viene con juegos?': 'Sí, llega con un catálogo amplio preinstalado según modelo y tarjeta. La selección puede variar por lote; recomendamos hacer copia de seguridad al recibirla.',
      'Puedo ampliar almacenamiento?': 'Sí. Usa doble MicroSD: una para sistema y otra para juegos. Puedes sustituirlas por tarjetas de mayor capacidad cuando quieras.',
      'Cuanto dura la bateria?': 'Entre 6 y 8 horas según brillo, volumen y sistema emulado.',
      'Tiene sticks analogicos?': 'Sí, doble stick analógico. Ideal para PS1, PSP y títulos 3D que necesitan control analógico.',
      'Es dificil configurar ArkOS?': 'No. Puedes jugar tal cual viene. Si quieres afinar, ArkOS permite ajustar brillo, filtros, mapeo de botones y organización de ROMs de forma clara.',
      'Cuanto tarda el envio?': 'El envío estimado es de 7 a 14 días laborables, con código de seguimiento.',
      'Puedo devolverla si no me convence?': 'Sí. Tienes 14 días desde la recepción (derecho de desistimiento UE). Si llega con algún defecto, te ayudamos con el cambio.'
    };
    byText('button', '?', APP).forEach(function (btn) {
      var q = (btn.querySelector('span') ? btn.querySelector('span').textContent : btn.textContent).trim();
      if (!FAQ[q]) return;
      var card = btn.parentElement;
      var ans = card.querySelector('.px-5.pb-5') || card.querySelector('div:last-child:not(:first-child)');
      if (!ans || ans === btn) {
        ans = document.createElement('div');
        ans.className = 'px-5 pb-5 text-sm text-[#8B95A8] leading-relaxed';
        ans.textContent = FAQ[q];
        card.appendChild(ans);
      } else { ans.textContent = FAQ[q]; }
      ans.style.display = 'none';
      var sign = btn.querySelectorAll('span'); var plus = sign[sign.length - 1];
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = ans.style.display !== 'none';
        ans.style.display = open ? 'none' : 'block';
        if (plus) plus.textContent = open ? '+' : '-';
      });
    });

    // ---- 7) Ocultar reseñas falsas + bloque Loox ----
    var rev = document.getElementById('reseñas') || document.getElementById('reseñas');
    if (rev) {
      var inner = rev.querySelector('.mx-auto') || rev;
      var keepHead = rev.querySelector('h2');
      rev.querySelectorAll('.grid').forEach(function (g) { g.style.display = 'none'; });
      var loox = document.createElement('div');
      loox.style.cssText = 'max-width:1000px;margin:0 auto;padding:0 24px;';
      loox.innerHTML = '<div id="looxReviews" data-product-id="' + (window.__R36PID || '') + '"></div>' +
        '<div style="text-align:center;color:#8B95A8;font-size:.9rem;padding:20px;border:1px solid rgba(255,255,255,.1);border-radius:14px;">Reseñas verificadas próximamente.</div>';
      (keepHead && keepHead.parentElement ? keepHead.parentElement : rev).appendChild(loox);
    }
    // ocultar escasez inventada y contadores de venta sueltos
    byText('span', 'Quedan', APP).forEach(function (n) { var p = n.closest('div'); if (p) p.style.display = 'none'; });
    byText('span', 'vendidas', APP).forEach(function (n) { n.style.display = 'none'; });
    // barrido final de cifras inventadas (ventas/reseñas)
    $$('span, p, h1, h2, h3, div').forEach(function (n) {
      var t = n.textContent || '';
      if (/2\.?847|2\.?800/.test(t) && n.children.length === 0) n.style.display = 'none';
    });

    // ---- 8) Carrito real ----
    function addToCart(go) {
      var v = findVar(state.s, state.c);
      if (!v) { window.location.href = '/products/consola-retro-r36s'; return; }
      if (!go && typeof window.dgchAddToCart === 'function') { window.dgchAddToCart(v.id, 1); return; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: v.id, quantity: 1 }) })
        .then(function () { window.location.href = go ? '/checkout' : '/cart'; })
        .catch(function () { window.location.href = '/cart'; });
    }
    $$('a, button').forEach(function (el) {
      var t = (el.textContent || '').trim();
      if (t === 'Comprar ahora' || t === 'Comprar') { el.addEventListener('click', function (e) { e.preventDefault(); addToCart(true); }); }
      else if (t === 'Anadir al carrito' || t === 'Añadir al carrito') { el.addEventListener('click', function (e) { e.preventDefault(); addToCart(false); }); }
    });

    // init
    updatePrice(); styleStorage();
  });
})();
